import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { passwordResetReq } from 'services/apiUsers';

const useForgotPassReq = () => {
  const queryClient = useQueryClient();

  const {isPending,isSuccess,data,mutate:forgotPassword} = useMutation({
    mutationFn: passwordResetReq,
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
    },
    onError:(error)=>{
        console.log("Error occurred when updating Org status",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })
  return{isPending,isSuccess,forgotPassword,data}
}

export default useForgotPassReq